import { create } from "zustand";

export const useSideBarStore = create((set) => ({
  isWorkManagement: false,
  isWorkManagementOptions: true,
  isOrganizationSideBar: false,
  isRecord: false,

  switchIsWorkManagement: () =>
    set((state) => ({ isWorkManagement: !state.isWorkManagement })),

  switchIsWorkManagementOptions: () =>
    set((state) => ({
      isWorkManagementOptions: !state.isWorkManagementOptions,
    })),

  setIsOrganizationSideBar: (value) =>
    set((state) => ({ isOrganizationSideBar: value })),

  switchIsRecord: (isRecord) => set((state) => ({ isRecord: isRecord })),
}));
